import { render, staticRenderFns } from "./payJp.vue?vue&type=template&id=0551e47a&"
import script from "./payJp.vue?vue&type=script&lang=ts&"
export * from "./payJp.vue?vue&type=script&lang=ts&"
import style0 from "./payJp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports